import { NgModule } from '@angular/core';
import { LanguagesService } from './languages.service';
import { LanguageDisplayPipe, LanguageDisplayArrayPipe } from './language-display.pipe';

@NgModule({
    declarations: [
        LanguageDisplayPipe,
        LanguageDisplayArrayPipe,
    ],
    providers: [
        LanguagesService,
    ],
    exports: [
        LanguageDisplayPipe,
        LanguageDisplayArrayPipe,
    ],
})
export class LanguagesModule { }
